






import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class EstateMap extends Vue {
    @Prop({ required: true }) lat!: number;

    @Prop({ required: true }) lng!: number;

    @Prop({ required: true }) address!: string;

    key: string = "AIzaSyADha0ry3TF3OkBy6BL2UnFzcn8TKbK2J0";
}
